import Segmentation from './presets.segmentation';
export { Segmentation as SegmentationPreset };
